/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { STAGE, STAGE_LABEL } from '../constants';

// Etapa do candidato no funil (read-only). Ver constants.STAGE.
const STAGE_VARIANT = {
   [STAGE.BANCO_CURRICULOS]: 'neutral',
   [STAGE.ENTREVISTA_1]: 'blue',
   [STAGE.ENTREVISTA_2]: 'blue',
   [STAGE.ONBOARDING]: 'amber',
   [STAGE.ADMITIDO]: 'green',
   [STAGE.ENCERRADO]: 'red',
};

export default function StageBadge({ value }) {
   return (
      <StatusBadge variant={STAGE_VARIANT[value] ?? 'neutral'}>
         {STAGE_LABEL[value] ?? value ?? '—'}
      </StatusBadge>
   );
}

StageBadge.propTypes = {
   value: PropTypes.string,
};
